import { createStore, createContainer, createHook, createActionsHook } from 'react-sweet-state';
import { actions } from './actions';
import type { Actions, IssueCreateIssueType, IssueCreateProject, Props, State } from './types';

export const IssueCreateFormContainer = createContainer<Props>();

const initialState: State = {
	project: null,
	issueType: null,
	summary: '',
};

const Store = createStore<State, Actions, Props>({
	containedBy: IssueCreateFormContainer,
	initialState,
	actions,
});

export const useIssueCreateProject = createHook<State, Actions, IssueCreateProject | null>(Store, {
	selector: ({ project }) => project,
});

export const useIssueCreateIssueType = createHook<State, Actions, IssueCreateIssueType | null>(
	Store,
	{
		selector: ({ issueType }) => issueType,
	},
);

export const useIssueCreateSummary = createHook<State, Actions, string>(Store, {
	selector: ({ summary }) => summary,
});

export const useIssueCreateActions = createActionsHook<State, Actions>(Store);
